/**
 * Created by Jerker Nord on 2023-10-13.
 */
import {LonerOfficeBuilding} from "../buildings/LonerOfficeBuilding";
import {LonerSchoolBuilding} from "../buildings/LonerSchoolBuilding";
import {LonerChurchBuilding} from "../buildings/LonerChurchBuilding";
import {LonerGameAssets} from "../../../../LonerGameAssets";
import {Loner} from "../../../../Loner";
import {gsap} from "gsap";

export class LonerSelectedResultContainer extends PIXI.Container {

    private static TOTAL_HEIGHT: number = 249;
    private static BUILDING_X_POS:number[] = [400, 1100, 1950];

    private _office: LonerOfficeBuilding;
    private _school: LonerSchoolBuilding;
    private _church: LonerChurchBuilding;
    private _selection: number;
    private _winRangeTextOrder:LonerOfficeBuilding[];
    private _cityBackgroundSprite: PIXI.Sprite;
    private _schoolBackgroundSprite: PIXI.Sprite;
    private _churchBackgroundSprite: PIXI.Sprite;

    constructor() {
        super();
        this.init();
    }

    private init(): void {
        this._cityBackgroundSprite = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.TTB_CITY_BACKGROUND)[0]);
        this.addChild(this._cityBackgroundSprite);
        this._cityBackgroundSprite.position.y = -42;

        this._churchBackgroundSprite = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.TTB_CHURCH_BACKGROUND)[0]);
        this.addChild(this._churchBackgroundSprite);
        this._churchBackgroundSprite.position.y = -42;

        this._schoolBackgroundSprite = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.TTB_SCHOOL_BACKGROUND)[0]);
        this.addChild(this._schoolBackgroundSprite);
        this._schoolBackgroundSprite.position.y = -42;

        this._office = new LonerOfficeBuilding();
        this._office.position.y = LonerSelectedResultContainer.TOTAL_HEIGHT;
        this._office.init(LonerGameAssets.TTB_OFFICE_BUILDING_PIXELS, LonerGameAssets.TTB_FIRE_ANIMATION);
        this.addChild(this._office);
        this._school = new LonerSchoolBuilding();
        this._school.init(LonerGameAssets.TTB_SCHOOL_BUILDING_PIXELS, LonerGameAssets.TTB_FIRE_ANIMATION);
        this._school.position.y = LonerSelectedResultContainer.TOTAL_HEIGHT + ((this._office.buildingSprite.height - this._school.buildingSprite.height) / 2);
        this.addChild(this._school);
        this._church = new LonerChurchBuilding();
        this._church.init(LonerGameAssets.TTB_CHURCH_BUILDING_PIXELS, LonerGameAssets.TTB_FIRE_ANIMATION);
        this._church.position.y = LonerSelectedResultContainer.TOTAL_HEIGHT + ((this._office.buildingSprite.height - this._church.buildingSprite.height) / 2);
        this.addChild(this._church);
    }

    public setOrder(selection: number): void {
        //1 = office, 2 = church, 3 = school
        this._selection = selection;
        this._winRangeTextOrder = [];
        if (selection == 1) {
            this._office.setText(Loner.model.winRange[2], true);
            this._office.position.x = LonerSelectedResultContainer.BUILDING_X_POS[2];
            this._winRangeTextOrder.unshift(this._office);
            this._church.setText(Loner.model.winValues[1].toString(), false);
            this._church.position.x = LonerSelectedResultContainer.BUILDING_X_POS[1];
            this._winRangeTextOrder.unshift(this._church);
            this._school.setText(Loner.model.winValues[0].toString(), false);
            this._school.position.x = LonerSelectedResultContainer.BUILDING_X_POS[0];
            this._winRangeTextOrder.unshift(this._school);

            this._schoolBackgroundSprite.position.x = -1;
            this._churchBackgroundSprite.position.x = this._schoolBackgroundSprite.width - 1;
            this._cityBackgroundSprite.position.x = this._churchBackgroundSprite.position.x + this._churchBackgroundSprite.width - 1;
        } else if (selection == 2) {
            this._church.setText(Loner.model.winRange[2], true);
            this._church.position.x = LonerSelectedResultContainer.BUILDING_X_POS[2];
            this._winRangeTextOrder.unshift(this._church);
            this._office.setText(Loner.model.winValues[1].toString(), false);
            this._office.position.x = LonerSelectedResultContainer.BUILDING_X_POS[1];
            this._winRangeTextOrder.unshift(this._office);
            this._school.setText(Loner.model.winValues[0].toString(), false);
            this._school.position.x = LonerSelectedResultContainer.BUILDING_X_POS[0];
            this._winRangeTextOrder.unshift(this._school);

            this._schoolBackgroundSprite.position.x = -1;
            this._cityBackgroundSprite.position.x = this._schoolBackgroundSprite.width - 1;
            this._churchBackgroundSprite.position.x = this._cityBackgroundSprite.position.x + this._cityBackgroundSprite.width - 1;
        } else {
            this._school.setText(Loner.model.winRange[2], true);
            this._school.position.x = LonerSelectedResultContainer.BUILDING_X_POS[2];
            this._winRangeTextOrder.unshift(this._school);
            this._office.setText(Loner.model.winValues[1].toString(), false);
            this._office.position.x = LonerSelectedResultContainer.BUILDING_X_POS[1];
            this._winRangeTextOrder.unshift(this._office);
            this._church.setText(Loner.model.winValues[0].toString(), false);
            this._church.position.x = LonerSelectedResultContainer.BUILDING_X_POS[0];
            this._winRangeTextOrder.unshift(this._church);

            this._churchBackgroundSprite.position.x = -1;
            this._cityBackgroundSprite.position.x = this._churchBackgroundSprite.width - 1;
            this._schoolBackgroundSprite.position.x = this._cityBackgroundSprite.position.x + this._cityBackgroundSprite.width - 1;
        }
    }

    public getShowWinRangeTL():gsap.core.Timeline{
        const showWinRangeTL:gsap.core.Timeline = gsap.timeline();
        showWinRangeTL.add(()=>this._winRangeTextOrder[0].showText(), "+=1");
        showWinRangeTL.add(()=>this._winRangeTextOrder[1].showText(), "+=1");
        showWinRangeTL.add(()=>this._winRangeTextOrder[2].showText(), "+=1");

        return showWinRangeTL;
    }

    public playFireAnimation(): void {
        //1 = office, 2 = church, 3 = school
        if (this._selection == 1) {
            this._office.playFireAnimation();
        } else if (this._selection == 2) {
            this._church.playFireAnimation();
        } else {
            this._school.playFireAnimation();
        }
    }

    public reset(): void {
        this._office.reset();
        this._church.reset();
        this._school.reset();
    }
}